import { createSlice } from "@reduxjs/toolkit";

const perfCycleSlice = createSlice({
  name: "perfCycle",
  initialState: { value: {} },
  reducers: {
    perfCycleDetails: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { perfCycleDetails } = perfCycleSlice.actions;
export default perfCycleSlice.reducer;
